module.exports = __webpack_public_path__ + "static/media/forreview.fe8de22f.png";